import { BaseColorKey } from 'src/app/core/theming/theme-token-catalog';

/**
 * Vriendelijke knop-kleurnamen, 1-op-1 met de Base Colors zoals getoond in de
 * Colors-tab van theming (Color 1…6 / Neutral / Error). De basisnaam mikt op de
 * `base`-rol van de accent-familie; met een rol-suffix kies je een nuance, bijv.
 * `color4-container` of `neutral-on`. Mappen op de theming-SSOT {@link BaseColorKey}
 * + accent-rollen (`--accent-{key}` / `--accent-{key}-{role}`).
 */
type ButtonColorBase =
    | 'color1' | 'color2' | 'color3' | 'color4' | 'color5' | 'color6'
    | 'neutral' | 'error';

/** Accent-rol-suffixen (de `base`-rol is de suffixloze variant). Sync met AccentRole. */
type AccentRoleSuffix = 'on' | 'container' | 'container-high' | 'on-container';

export type ButtonColor = ButtonColorBase | `${ButtonColorBase}-${AccentRoleSuffix}`;

const BASE_TO_KEY: Record<ButtonColorBase, BaseColorKey> = {
    color1: 'c1', color2: 'c2', color3: 'c3', color4: 'c4',
    color5: 'c5', color6: 'c6', neutral: 'neutral', error: 'error',
};

const ROLE_SUFFIXES: AccentRoleSuffix[] = ['on', 'container', 'container-high', 'on-container'];

/**
 * Resolve een {@link ButtonColor} naar de bijbehorende accent-CSS-var
 * (`var(--accent-c4)` / `var(--accent-c4-container)`), of `null` als er geen kleur is.
 */
export function resolveButtonColorVar(value: ButtonColor | null | undefined): string | null {
    if (!value) return null;
    for (const __base of Object.keys(BASE_TO_KEY) as ButtonColorBase[]) {
        const __key = BASE_TO_KEY[__base];
        if (value === __base) return `var(--accent-${__key})`;
        for (const __role of ROLE_SUFFIXES) {
            if (value === `${__base}-${__role}`) return `var(--accent-${__key}-${__role})`;
        }
    }
    return null;
}
